import ClientAddPage from './client-add';

export default ClientAddPage;